import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

interface TermsSwitchProps {
  onChange: (checked: boolean) => void;
  initialState?: boolean;
}

const TermsSwitch: React.FC<TermsSwitchProps> = ({
  onChange,
  initialState = false,
}) => {
  const [isChecked, setIsChecked] = useState(initialState);
  const { t } = useTranslation();

  const handleChange = () => {
    const newState = !isChecked;
    setIsChecked(newState);
    onChange(newState);
  };

  return (
    <label className="flex items-center w-full justify-between cursor-pointer gap-3 select-none">
      <span className="text-md font-semibold">
        {t("common.agree")}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          className="underline cursor-pointer"
          to={`${import.meta.env.VITE_TERMS_AND_CONDITIONS_URL}`}
        >
          {t("common.terms")}
        </Link>
      </span>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        className="sr-only"
      />

      <div className="relative">
        <div
          className={`
            w-12 h-6 rounded-full transition-colors duration-200 ease-in-out
            ${isChecked ? "bg-green-600" : "bg-gray-200"}
          `}
        >
          <div
            className={`
              absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full 
              shadow-md transform transition-transform duration-200 ease-in-out
              ${isChecked ? "translate-x-6" : "translate-x-0"}
            `}
          />
        </div>
      </div>
    </label>
  );
};

export default TermsSwitch;
